import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isExternal, splitHref } from './navData';

/**
 * Follow a navData href from an <a onClick>.
 * Static builds (/docs/, /demo/) and mailto: are left to the browser. SPA
 * routes go through the router; `/#id` style links change the hash, and
 * ScrollToTop in Routes.js scrolls the target into view once it renders.
 * Clicking the hash you are already on just scrolls to it again.
 */
const useNavTo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback((href, e) => {
    if (isExternal(href)) return;
    if (e) e.preventDefault();
    const { path, hash } = splitHref(href);
    if (location.pathname === path && hash && location.hash === `#${hash}`) {
      const el = document.getElementById(hash);
      const target = el && ((el.dataset.scrollTarget && document.getElementById(el.dataset.scrollTarget)) || el);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    navigate(href);
  }, [navigate, location.pathname, location.hash]);
};

export default useNavTo;
